require('./recoverFile.style.scss');
const FlrFolder = require('../../../../model/FolderItem');

const FILE_STATE = 'file',
    DISK_STATE = 'disk',
    OPTIONS_STATE = 'options',
    PICK_STATE = 'pick',
    HELP_ID = 'files-restore',
    PICK_STATE_VMS = 'VMS',
    PICK_STATE_FILESHARES = 'FILESHARES';

const tiers = [
    { tier: 'SNAPSHOT', label: 'Backup (SNAPSHOT)', targetType: 'SNAPSHOT' },
    { tier: 'BACKUP', label: 'Backup (TARGET)', targetType: 'TARGET' },
    { tier: 'COPY', label: 'Copy', targetType: 'TARGET' },
    { tier: 'ARCHIVE_DAILY', label: 'Archive - daily', targetType: 'TARGET' },
    { tier: 'ARCHIVE_WEEKLY', label: 'Archive - weekly', targetType: 'TARGET' },
    { tier: 'ARCHIVE_MONTHLY', label: 'Archive - monthly', targetType: 'TARGET' },
    { tier: 'ARCHIVE_YEARLY', label: 'Archive - yearly', targetType: 'TARGET' },
];

class RecoverFileController {
    constructor(
        $scope,
        $element,
        $timeout,
        $q,
        $filter,
        $rootScope,
        virtualMachinesPersistence,
        recoverFileService,
        contentSwitcherService,
        notificationService
    ) {
        this.$scope = $scope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$filter = $filter;
        this.$rootScope = $rootScope;
        this.persistence = virtualMachinesPersistence;
        this.recoverFileService = recoverFileService;
        this.state = OPTIONS_STATE;
        this.contentSwitcherService = contentSwitcherService;
        this.notificationService = notificationService;
        this.modalSubTitle = null;
        this.filteredTiers = [];
        this.fullDiskSelected = false;
        this.skipAbort = true;
        this.unmountedDiskSelected = false;
        this.vmDiscoveryFailed = false;

        // TODO
        this.defaultTier = { label: 'Automatic', value: 'AUTO', isDefault: true, isOriginal: true, isSelected: true };
        this.tier = this.defaultTier;

        this.elements = [];
        this.target = 'image';
        this.pick = PICK_STATE_VMS;
        this.restoreTargetPath = '';
        this.restoreOverwriteMode = 'OVERWRITE';
        this.restoreACLs = false;
        this.sharedPath = /^\\\\/;
        this.username = /\\/;
        this.isMounted = false;
        this.flrTaskId = undefined;

        this.selectedTarget = null;

        this.targetOptions = [
            { name: this.$filter('translate')('vm.restoreFile.tab.original'), value: 'image' },
            { name: this.$filter('translate')('vm.restoreFile.tab.alternate'), value: 'vm' },
        ];
        this.modeOptions = [
            { name: this.$filter('translate')('vm.restoreFile.mode.overwrite'), value: 'OVERWRITE' },
            { name: this.$filter('translate')('vm.restoreFile.mode.rename.original'), value: 'RENAME_ORIGINAL' },
            { name: this.$filter('translate')('vm.restoreFile.mode.rename.restored'), value: 'RENAME_RESTORED' },
        ];
        this.restoreToPicks = [
            {
                name: this.$filter('translate')('vm.restoreFile.pick.virtualMachine.label'),
                label: this.$filter('translate')('vm.restoreFile.pick.virtualMachine'),
                value: PICK_STATE_VMS,
                isDisabled: () => this.isVmDeleted || this.vmDiscoveryFailed,
                disabledMessage: this.$filter('translate')('vm.restore.options.disabledMessage.partTwo'),
            },
            {
                name: this.$filter('translate')('vm.restoreFile.pick.target.label'),
                label: this.$filter('translate')('vm.restoreFile.pick.target'),
                value: PICK_STATE_FILESHARES,
            },
        ];
    }

    $onInit() {
        this.skipAbort = true;
        this.fileExplorerRdy = false;
        this.disk = new FlrFolder();
        this.restoreFlag = false;
        this.actionButton = [
            {
                title: this.$filter('translate')('toolbar.default.back.label'),
                action: () => {
                    if (this.state === FILE_STATE) {
                        this.disk = new FlrFolder();
                        this.selectedFiles = [];
                        this.isMounted = false;
                    }
                    this.carousel.prev();
                    this.isRestoreValid = false;
                },
                isVisible: () => this.state === DISK_STATE || this.state === PICK_STATE || this.state === FILE_STATE,
            },
            {
                title: this.$filter('translate')('vm.restore.dialog.btn.next'),
                action: () => {
                    this.next();
                },
                isVisible: () => !this.restoreFlag || this.state === OPTIONS_STATE,
                isDisabled: () => this.isNextDisabled(),
            },
            {
                title: this.$filter('translate')('vm.restore.dialog.btn.validate'),
                action: () => {
                    this.validateRestore();
                },
                isDisabled: () => this.restoreForm && !this.restoreForm.$valid,
                isVisible: () => this.state === PICK_STATE && this.restoreFlag,
            },
            {
                title: this.$filter('translate')('vm.restoreFile.button.restore.label'),
                action: () => this.restore(),
                isVisible: () => this.restoreFlag && this.state === PICK_STATE,
                isDisabled: () => (this.restoreForm && !this.restoreForm.$valid) || this.busy || !this.isRestoreValid,
            },
        ];

        this.$scope.$watch(
            () => this.path,
            (path) => {
                if (path === 'image') {
                    this.restoreTargetPath = '';
                    this.isRestoreValid = false;
                } else {
                    this.restoreOverwriteMode = 'OVERWRITE';
                    this.isRestoreValid = false;
                }
            }
        );

        this.$scope.$watch(
            () => this.unmountedDiskSelected,
            (unmountedDiskSelected) => {
                if (unmountedDiskSelected) {
                    this.path = 'vm';
                } else {
                    this.path = 'image';
                }
            }
        );

        this.$scope.$watch(
            () => this.restoreOverwriteMode,
            (newVal, oldVal) => {
                if (newVal !== oldVal && newVal) {
                    this.isRestoreValid = false;
                }
            }
        );

        this.$scope.$watch(
            () => this.restoreTargetPath,
            (newVal, oldVal) => {
                if (newVal !== oldVal && newVal) {
                    this.isRestoreValid = false;
                }
            }
        );

        this.$scope.$watch(
            () => this.restoreACLs,
            (newVal, oldVal) => {
                if (newVal !== oldVal && newVal) {
                    this.isRestoreValid = false;
                }
            }
        );

        this.$scope.$watch(
            () => this.target,
            (newVal, oldVal) => {
                if (newVal !== oldVal && newVal) {
                    this.isRestoreValid = false;
                }
            }
        );
    }

    onOpen() {
        this.recoverOptions = [];
        this.recoverOptions.push({
            id: 0,
            label: 'Automatic',
            value: null,
            selected: true,
        });
        for (let i = 0; i < this.selectedVersion.backupTiers.length; i++) {
            let filteredTiers = tiers.filter(
                (item) =>
                    this.selectedVersion.backupTiers[i].targetType === item.targetType &&
                    this.selectedVersion.backupTiers[i].backupType === item.tier &&
                    this.selectedVersion.backupTiers[i].state !== 'EXPIRED'
            );
            if (filteredTiers.length) {
                this.setValues(filteredTiers[0], i + 1);
            }
        }

        this.tier = this.recoverOptions[0];

        this.availableDisks = this.selectedVersion.disks
            .filter((disk) => disk.catalog !== null)
            .map((elem, i) => {
                elem.catalog;
                return {
                    id: i,
                    label: elem.name,
                    value: elem.catalog,
                };
            });
        this.disks = [];
        this.availableDisks.forEach((disk) => {
            disk.selected = true;
            this.disks.push(disk);
        });

        this.persistence.getTargetsFLR().then((res) => {
            this.availableTargets = res;
            this.target = this.availableTargets[0];
            this.selectedTarget = this.availableTargets[0];
            this.displayedTargets = this.availableTargets;
        });
        this.isVmDeleted = this.selectedVm.protection === 'PROTECTED_DELETED';
        this.restoreToPicks[0].isDisabled = this.isVmDeleted;
        this.pick = this.selectedVm.protection === 'PROTECTED_DELETED' ? PICK_STATE_FILESHARES : PICK_STATE_VMS;

        if (!this.isVmDeleted) {
            if (this.selectedVm.discoveryStatus !== 'OK') {
                this.vmDiscoveryFailed = true;
                this.restoreToPicks[0].isDisabled = this.vmDiscoveryFailed;
                this.restoreToPicks[0].warningMessage = this.$filter('translate')(
                    'vm.restore.options.disabledMessage.discoveryFailed'
                );
                this.restoreToPicks[0].disabledMessage = null;
                this.pick = PICK_STATE_FILESHARES;
            }
        }

        this.busy = false;
        this.fileExplorerRdy = false;

        this.selectedItem = {};
        this.selectedFiles = [];
        this.recoverFileService.getPageNumber();
        this.errorFlag = false;
        this.path = 'image';
        this.restoreTargetPath = '';
        this.modalSubTitle = null;
        this.restoreOverwriteMode = 'OVERWRITE';
        this.restoreACLs = false;
        this.isPastDiscovery = false;
        this.displayedTargets = [];
        this.targetSearch = {};
        if (this.taskId) {
            this.flrTaskId = this.taskId;
            this.isPastDiscovery = true;
            this.checkForReady(this.discoveryStatus);
            this.carousel.next();
        } else {
            this.showOptionsState();
        }

        this.$timeout(() => {
            this.carouselIsVisible = true;
        }, 500);

        this.deregisterCpt = this.$scope.$watch(
            () => this.selectedItem.completitionPct,
            (value) => {
                if (!value) return;
                this.errorFlag = value === -1;
            }
        );
        this.deregisterJobStatus = this.$scope.$watch(
            () => this.selectedItem.mountingJobStatus,
            (jobStatus) => {
                if (!jobStatus) return;
                this.errorFlag = this.recoverFileService.rejectStates.indexOf(jobStatus) >= 0;
            }
        );
        this.deregisterElements = this.$scope.$watchCollection(
            () => this.selectedItem.elements,
            (elements) => {
                this.elements = elements ? elements : [];
            }
        );
    }

    setValues(tier, index) {
        this.recoverOptions.push({
            id: index,
            label: tier.label,
            value: tier.tier,
            selected: true,
        });
    }

    searchTarget() {
        if (angular.isUndefined(this.targetSearch.searchBy)) return;
        this.displayedTargets = this.availableTargets.filter(
            (target) => target.label.toLowerCase().indexOf(this.targetSearch.searchBy.toLowerCase()) !== -1
        );
    }

    isNextDisabled() {
        if (this.state === DISK_STATE) {
            return (
                (this.dialogForm && !this.dialogForm.$valid) ||
                this.busy ||
                !this.disks ||
                this.disks.length === 0 ||
                !this.availableDisks ||
                this.availableDisks.length === 0 ||
                this.disableNext
            );
        } else if (this.state === FILE_STATE) {
            let sNodes =
                this.selectedFiles &&
                this.selectedFiles
                    .filter((item) => (!item.parent && item._selected) || (item.parent && !item.parent._selected))
                    .map((file) => file.fullItemName);
            for (var i = 0; i < sNodes.length; i++) {
                let nodeLength = sNodes[i].length;
                let lastCharacter = sNodes[i].charAt(nodeLength - 1);
                let sNode = sNodes[i];
                if (sNodes[i].split('/').length === 4 && lastCharacter !== '/') {
                    sNode = sNodes[i] + '/';
                }
                if (sNode.split('/').length === 2 || sNode.split('/').length === 4 || sNode === '') {
                    this.fullDiskSelected = true;
                    break;
                }
                this.fullDiskSelected = false;
            }
            return !this.nodesSelected || this.fullDiskSelected || this.disableNext;
        }
        return this.disableNext;
    }

    next() {
        this.disableNext = true;
        if (this.state === DISK_STATE) {
            this.isMounted = true;
            this.discover();
        } else {
            this.filterSelectedNodes();
        }

        setTimeout(() => {
            this.disableNext = false;
        }, 1000);
        this.carousel.next();
    }

    discover() {
        let diskNames = [];
        (this.disks || []).forEach((disk) => {
            diskNames.push(disk.value);
        });
        let data = {
            restoreType: 'FLR',
            restoreSource: {
                restorePointId: this.selectedVersion.uuid,
                diskNames: diskNames,
            },
        };
    }

    showDiskState() {
        this.helpId = null;
        this.modalTitle = this.$filter('translate')('vm.restoreFile.diskChoice.title');
        this.helpId = null;
        this.restoreFlag = false;
        this.state = DISK_STATE;
        this.modalSubTitle = null;
    }

    showFileState() {
        this.selectedDisks = [];
        this.disks.forEach((disk) => {
            if (disk.selected) {
                this.selectedDisks.push({
                    catalogName: disk.value,
                    diskName: disk.label,
                });
            }
        });

        this.helpId = null;
        this.modalTitle = this.$filter('translate')('vm.restoreFile.title');
        this.helpId = null;
        this.restoreFlag = false;
        this.state = FILE_STATE;
        this.modalSubTitle = null;
        this.skipAbort = false;
    }

    showPickState() {
        this.state = PICK_STATE;
        this.helpId = null;
        this.restoreFlag = true;
        this.modalTitle = this.$filter('translate')('vm.restoreSingleFile.title');
        this.modalSubTitle =
            this.pick === 'VMS'
                ? ' » ' + this.$filter('translate')('vm.restoreFile.pick.virtualMachine.title')
                : ' » ' + this.$filter('translate')('vm.restoreFile.pick.target.title');
    }

    showOptionsState() {
        this.modalTitle = this.$filter('translate')('vm.restoreFile.pick.title');
        this.helpId = HELP_ID;
        this.state = OPTIONS_STATE;
        this.modalSubTitle = null;
    }

    onTitleClick() {
        this.showOptionsState();
        this.carousel.prev();
    }

    setCarousel(carousel) {
        this.carousel = carousel;
    }

    checkForReady(discoveryStatus) {
        if (discoveryStatus === 'RUNNING') {
            this.fileExplorerRdy = true;
        } else if (discoveryStatus === 'READY') {
            this.discoveryInProcess = true;
            this.waitForDiscovery = this.$rootScope.$on(
                'restore.discovery.reached.' + this.selectedVersion.vmName,
                () => {
                    this.fileExplorerRdy = true;
                    this.discoveryInProcess = false;
                    this.waitForDiscovery();
                    this.waitForDiscovery = null;
                }
            );
        }
    }

    validateRestore() {
        let data = this.setRestoreData();
        this.busy = true;
        this.persistence
            .validateRestore(data)
            .then((resp) => {
                resp.statusCode === 200 ? (this.isRestoreValid = true) : false;
                if (resp.message) this.notificationService.pop(resp.message);
            })
            .finally(() => (this.busy = false));
    }

    setRestoreData() {
        let flrData = {};
        flrData.selectedItems = this.selectedNodes;
        if (this.pick === 'VMS') {
            flrData.onVirtualMachine = true;
            flrData.targetPath = this.restoreTargetPath || null;
            flrData.restoreAcl = this.restoreACLs || false;
            flrData.flrVirtualMachineMode = this.restoreOverwriteMode;
        } else {
            flrData.onVirtualMachine = false;
        }

        let data = {
            restoreType: 'FLR',
            flrData: flrData,
            restoreSource: {
                restorePointUuid: this.selectedVersion.uuid,
                tier: this.tier.value,
                diskNames: this.selectedDisks.map((disk) => {
                    return disk.diskName;
                }),
            },
            restoreTarget: {},
        };

        if (this.pick === 'VMS') {
            data.restoreTarget.subscriptionUuid = this.selectedVm.subscriptionUuid;
            data.restoreTarget.resourceGroup = this.selectedVm.resourceGroup;
            data.restoreTarget.virtualMachineName = this.selectedVersion.vmName;
            data.restoreTarget.location = this.selectedVm.location;
            data.restoreTarget.virtualNetwork = this.selectedVm.virtualNetwork;
        } else {
            data.restoreTarget.subscriptionUuid = this.selectedVm.subscriptionUuid;
            data.restoreTarget.resourceGroup = this.selectedTarget.resourceGroup;
            data.restoreTarget.targetUuid = this.selectedTarget.value;
            data.restoreTarget.storageAccountName = this.selectedTarget.name;
            data.restoreTarget.virtualMachineName = this.selectedVersion.vmName;
            data.restoreTarget.location = this.selectedVm.location;
            data.restoreTarget.virtualNetwork = this.selectedVm.virtualNetwork;
        }

        return data;
    }

    restore() {
        let data = this.setRestoreData();
        this.selectedItem.restoreFlag = true;
        this.busy = this.persistence.restore(data).then(() => {
            this.vmsCtrl.refreshBackups(false);
            this.skipAbort = true;
            this.showModal = false;
        });
    }

    filterSelectedNodes() {
        this.selectedNodes = this.selectedFiles
            .filter((item) => (!item.parent && item._selected) || (item.parent && !item.parent._selected))
            .map((file) => file.fullItemName);
    }

    onClose() {
        this.discoveryInProcess = false;
        if (this.waitForDiscovery) this.waitForDiscovery();
        if (this.runningTimeout) this.$timeout.cancel(this.runningTimeout);
        this.disk.clear();
        this.carouselIsVisible = false;
        this.elements = [];
        this.modalSubTitle = null;
        this.errorFlag = false;
        this.nodesSelected = false;
        this.nodesSelected = false;
        this.selectedNodes = [];
        this.pick = PICK_STATE_VMS;
        this.isRestoreValid = false;
        if (this.deregisterCpt) this.deregisterCpt();
        if (this.deregisterJobStatus) this.deregisterJobStatus();
        if (this.deregisterElements) this.deregisterElements();

        if (this.checkIfMountExist()) {
            this.unmount();
        } else {
            this.selectedItem = {};
        }
        if (!this.skipAbort) {
            this.persistence.abortFLR(this.selectedVersion.uuid);
        }
        this.skipAbort = false;
        this.onClosed();
    }

    checkIfMountExist() {
        return (
            this.selectedVersion &&
            this.selectedItem &&
            this.selectedItem.uuid &&
            this.selectedVersion.uuid === this.selectedItem.uuid &&
            !this.selectedItem.restoreFlag &&
            this.selectedItem.mountUuid &&
            this.selectedItem.jobType === 'MOUNT_SNAPSHOT' &&
            this.selectedItem.completitionPct === 1
        );
    }

    fetchFolderContent(folder = this.disk) {
        return this.recoverFileService.fetchFolderContent(folder, this.selectedVersion.uuid, this.selectedDisks);
    }

    fetchFolders(folder = this.disk) {
        return this.recoverFileService.fetchFolder(folder, this.selectedVersion.uuid, this.selectedDisks);
    }
}

RecoverFileController.$inject = [
    '$scope',
    '$element',
    '$timeout',
    '$q',
    '$filter',
    '$rootScope',
    'virtualMachinesPersistence',
    'recoverFileService',
    'contentSwitcherService',
    'notificationService',
];

const recoverFileComponent = {
    controller: RecoverFileController,
    require: {
        vmsCtrl: '^^virtualMachines',
    },
    template: require('./recoverFile.template.html'),
    bindings: {
        showModal: '=',
        onClosed: '&onClose',
        selectedVersion: '=',
        taskId: '<',
        discoveryStatus: '<',
        selectedVm: '=',
    },
};

module.exports = recoverFileComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/virtualMachines/dialogs/recoverFile/recoverFile.component.js